<template>
  <div v-if="$warehouseId">
    <div v-if="loading" class="align-self-stretch text-center">
      <p class="mb-4 text-h6">Loading ...</p>
      <v-progress-linear color="secondary" indeterminate rounded height="8"> </v-progress-linear>
    </div>
    <template v-else>
      <create-appointment-form
        :context="{ selectedWarehouse: $warehouse, selectedCarrier: $me }"
        @scheduled="handleScheduled">
      </create-appointment-form>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      isScheduled: false
    };
  },
  methods: {
    handleScheduled() {
      this.isScheduled = true;
    }
  }
};
</script>
